import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { HowToPlayScene } from "./scenes/MainScene";

interface PhaserDiagnosisGameProps {
    onComplete: () => void;
}

interface PhaserDiagnosisGameState {
}

const gameConfig: GameConfig = {
    title: "Diagnosis Game",
    version: "0.9.3",
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 200 }
        }
    },
    backgroundColor: "#000000",
};

class PhaserDiagnosisGame extends React.Component<PhaserDiagnosisGameProps, PhaserDiagnosisGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserDiagnosisGameProps) {
        super(props);
        bindAllOfThis(this, PhaserDiagnosisGame.prototype);
    }

    render() {
        // JB: Yes, there is only a HowToPlay Scene. This is a game from the first round did not have the love the other games had
        return (<div>
            <PhaserGameComponent scenes={HowToPlayScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserDiagnosisGame;



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/Main.tsx